import { OffersFacade } from '@/_store/offers/offers.facade';
import { Selected } from '@/_store/offers/offers.types';
import { TopSearchDropdownItemMode } from '@/new-top-search/top-search-dropdown-item/top-search-dropdown-item.types';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-top-search-advanced-filter-wrapper',
	templateUrl: './top-search-advanced-filter-wrapper.component.html',
	styleUrls: ['./top-search-advanced-filter-wrapper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSearchAdvancedFilterWrapperComponent {
	@Input({ required: true }) title = '';
	@Input() iconClass = 'fa-regular fa-map';
	/** When set to kinds / boards / conveniences, header shows selected count + clear. */
	@Input() filterMode?: TopSearchDropdownItemMode;

	@Output() readonly cleared = new EventEmitter<void>();

	readonly offersFacade = inject(OffersFacade);

	readonly multiChoiceCount$ = this.offersFacade.selected$.pipe(
		map((selected) => this.multiChoiceSelectedCount(selected)),
	);

	get isMultiChoiceHeader(): boolean {
		return (
			this.filterMode === TopSearchDropdownItemMode.KINDS ||
			this.filterMode === TopSearchDropdownItemMode.BOARDS ||
			this.filterMode === TopSearchDropdownItemMode.CONVENIENCES
		);
	}

	clearMultiChoice(ev: MouseEvent): void {
		ev.preventDefault();
		ev.stopPropagation();
		switch (this.filterMode) {
			case TopSearchDropdownItemMode.KINDS:
				this.offersFacade.clearKindsFilter();
				break;
			case TopSearchDropdownItemMode.BOARDS:
				this.offersFacade.clearBoardsFilter();
				break;
			case TopSearchDropdownItemMode.CONVENIENCES:
				this.offersFacade.clearConveniencesFilter();
				break;
			default:
				return;
		}
		this.cleared.emit();
	}

	private multiChoiceSelectedCount(selected: Selected): number {
		switch (this.filterMode) {
			case TopSearchDropdownItemMode.KINDS:
				return selected.kinds?.length ?? 0;
			case TopSearchDropdownItemMode.BOARDS:
				return selected.boards?.length ?? 0;
			case TopSearchDropdownItemMode.CONVENIENCES:
				return selected.conveniences?.length ?? 0;
			default:
				return 0;
		}
	}
}
